import { HOME } from '~/utils/constants/routes'

export default (ctx) => {
  return ctx.redirect(HOME)
}
